module.exports = __webpack_public_path__ + "img/4-Wire & Cable Technology International.9ae7125a.png";